import { useEffect, useRef, useState } from 'react';

// Показывает "теневую" полосу горизонтальной прокрутки, прижатую к низу экрана, для той
// широкой таблицы (.table-wrap с реальным горизонтальным overflow), что сейчас хотя бы
// частично видна на экране — чтобы сдвинуть её по горизонтали не нужно было сначала
// долистывать страницу до конца самой таблицы, где обычно и находится её родная полоса.
// Смонтирован один раз в Layout — работает для любой .table-wrap на любой странице, не
// требует правок в самих страницах/таблицах.
export default function StickyHScrollbar() {
  const [target, setTarget] = useState(null);
  const shadowRef = useRef(null);
  const syncingRef = useRef(false);

  useEffect(() => {
    const find = () => {
      const wraps = document.querySelectorAll('.table-wrap');
      for (const wrap of wraps) {
        if (wrap.scrollWidth <= wrap.clientWidth + 1) continue;
        const rect = wrap.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight && rect.width > 0) {
          return { wrap, left: rect.left, width: rect.width, scrollWidth: wrap.scrollWidth };
        }
      }
      return null;
    };

    const update = () => {
      const found = find();
      setTarget(prev => {
        if (!found) return prev === null ? prev : null;
        if (prev && prev.wrap === found.wrap && prev.left === found.left
          && prev.width === found.width && prev.scrollWidth === found.scrollWidth) return prev;
        return found;
      });
    };

    update();
    window.addEventListener('scroll', update, { passive: true, capture: true });
    window.addEventListener('resize', update);
    // Ширина/контент таблицы может измениться без scroll/resize (фильтр, догрузка данных) —
    // лёгкий поллинг проще и надёжнее, чем ставить MutationObserver на каждую таблицу отдельно.
    const interval = setInterval(update, 500);

    return () => {
      window.removeEventListener('scroll', update, { capture: true });
      window.removeEventListener('resize', update);
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (!target || !shadowRef.current) return;
    const shadow = shadowRef.current;
    const wrap = target.wrap;
    shadow.scrollLeft = wrap.scrollLeft;

    const onShadowScroll = () => {
      if (syncingRef.current) return;
      syncingRef.current = true;
      wrap.scrollLeft = shadow.scrollLeft;
      syncingRef.current = false;
    };
    const onWrapScroll = () => {
      if (syncingRef.current) return;
      syncingRef.current = true;
      shadow.scrollLeft = wrap.scrollLeft;
      syncingRef.current = false;
    };
    shadow.addEventListener('scroll', onShadowScroll, { passive: true });
    wrap.addEventListener('scroll', onWrapScroll, { passive: true });
    return () => {
      shadow.removeEventListener('scroll', onShadowScroll);
      wrap.removeEventListener('scroll', onWrapScroll);
    };
  }, [target]);

  if (!target) return null;

  return (
    <div
      ref={shadowRef}
      className="sticky-hscroll"
      style={{
        position: 'fixed', left: target.left, width: target.width, bottom: 0,
        height: 14, overflowX: 'auto', overflowY: 'hidden', zIndex: 90,
      }}
    >
      <div style={{ width: target.scrollWidth, height: 1 }} />
    </div>
  );
}
